import axios from "axios";
import querystring from "querystring";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
const token = localStorage.getItem('user-token');
const user = localStorage.getItem('user-id');
if (token && user) {
    axios.defaults.headers.common['X-Authorization'] = 'Bearer ' + token;
    axios.defaults.headers.common['X-User'] = user;
}

/*const config = {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
};*/

const getters = {
    BDDSFACTLIST: state => {
        return state.bddsfactlist;
    },
};
const mutations = {
    SET_BDDSFACTLIST: (state, payload) => {
        state.bddsfactlist = payload;
    },

};
const actions = {
    // eslint-disable-next-line no-unused-vars
    GET_BDDSFACTLIST: async (context, payload) => {
        const req = querystring.stringify(payload);
        try {
            let {data} = await axios.get('/budget-api/bddsfact/list?' + req);
            context.commit('SET_BDDSFACTLIST', data);
            return data;
        } catch (err) {
            return err;
        }
    },
    EXCEL_BDDSFACTLIST: async (context, payload) => {
        const req = querystring.stringify(payload);
        try {
            let {data} = await axios.get('/budget-api/bddsfact/excellist?' + req);
            return data;
        } catch (err) {
            return err;
        }
    },
};


export default {
    state: () => ({
        bddsfactlist: null,
    }),
    mutations,
    actions,
    getters
};
